angular
  .module('resources.AdminUser', ['ngResource'])
  .factory('AdminUser', ['$resource', function ($resource) {
    var Resource = $resource('/api/admin/users/:id', {id: '@_id'}, {
      query: {
        method: 'GET',
        isArray: false
      },
      update: {
        method: 'PUT'
      },
      search: {
        method: 'GET',
        url: '/api/admin/users-search',
        isArray: true
      },
      getAll: {
        method: 'GET',
        url: '/api/admin/users',
        isArray: false
      }
    });

    return Resource;
  }]);



// WEBPACK FOOTER //
// ./client/src/common/resources/AdminUser.js